var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicantsTenantsHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9999 10.2C18.548 10.2 17.3709 11.3771 17.3709 12.829C17.3709 14.2809 18.548 15.4579 19.9999 15.4579C21.4518 15.4579 22.6288 14.2809 22.6288 12.829C22.6288 11.3771 21.4518 10.2 19.9999 10.2ZM16.4709 12.829C16.4709 10.88 18.0509 9.30005 19.9999 9.30005C21.9489 9.30005 23.5288 10.88 23.5288 12.829C23.5288 14.778 21.9489 16.3579 19.9999 16.3579C18.0509 16.3579 16.4709 14.778 16.4709 12.829Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 7.20005C8.2633 7.20005 6.45005 9.0133 6.45005 11.25C6.45005 13.4868 8.2633 15.3 10.5 15.3C12.7368 15.3 14.55 13.4868 14.55 11.25C14.55 9.0133 12.7368 7.20005 10.5 7.20005ZM5.55005 11.25C5.55005 8.51624 7.76624 6.30005 10.5 6.30005C13.2339 6.30005 15.45 8.51624 15.45 11.25C15.45 13.9839 13.2339 16.2 10.5 16.2C7.76624 16.2 5.55005 13.9839 5.55005 11.25Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4501 26.2H0.550049V25.75C0.550049 23.5823 1.50947 21.6164 3.06441 20.1328C4.89373 18.3875 7.55388 17.3 10.5 17.3C11.9978 17.3 13.4205 17.581 14.6976 18.0858C18.0586 19.4144 20.4501 22.3201 20.4501 25.75V26.2ZM10.5 18.2C7.77144 18.2 5.33786 19.2076 3.68569 20.784C2.39625 22.0142 1.58694 23.585 1.46588 25.3H19.5342C19.3366 22.5094 17.3099 20.0862 14.3667 18.9228C13.1958 18.4599 11.8854 18.2 10.5 18.2Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.157 23.2001L21.1111 23.0639C21.0556 22.899 20.9951 22.7361 20.9298 22.5754L20.8179 22.3001H26.0258C25.8342 20.5198 24.5132 18.9699 22.5932 18.2109C21.8088 17.9009 20.93 17.7264 19.9999 17.7264C19.0781 17.7264 18.2072 17.8977 17.4289 18.2022L17.3318 18.2401L17.2451 18.1823C17.0791 18.0716 16.9097 17.9651 16.7372 17.863L16.4055 17.6666L16.757 17.5085C17.7276 17.0719 18.8319 16.8264 19.9999 16.8264C21.0424 16.8264 22.0336 17.022 22.9241 17.374C25.2648 18.2993 26.9499 20.3321 26.9499 22.7501V23.2001H21.157Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantsTenantsHover);
export default __webpack_public_path__ + "static/media/applicants-tenants-hover.5a5bcc35.svg";
export { ForwardRef as ReactComponent };